import React from "react";
import "../../../Tabs.css";
import RemainingDaysBadge from "../common/RemainingDaysBadge";
import { calculateParticipationStatus } from "../../../../../../utils/helpers";

const ShoppingAdTable = ({
  adData,
  statusFilter,
  searchTerm,
  onViewAd,
  getStatusClass,
  getStatusText,
  selectedAds, // ✅ 부모에서 받은 상태
  onSelectAll, // ✅ 부모에서 받은 함수
  onSelectAd, // ✅ 부모에서 받은 함수
  onOpenRankCheck, // ✅ 순위체크 모달 열기 함수
  keywordData, // 부모에서 받은 키워드 데이터
}) => {
  // 개별 광고 선택/해제 함수
  const handleSelectAd = (adId) => {
    if (selectedAds.includes(adId)) {
      onSelectAd(adId); // 부모의 함수 호출
    } else {
      onSelectAd(adId); // 부모의 함수 호출
    }
  };

  // 전체 선택/해제 함수
  const handleSelectAll = (approvedAds) => (e) => {
    if (selectedAds.length === approvedAds.length) {
      onSelectAll(approvedAds)(e); // 부모의 함수 호출
    } else {
      onSelectAll(approvedAds)(e); // 부모의 함수 호출
    }
  };

  const approvedAds = adData.filter((ad) => ad.status === "APPROVED");
  const isAllApprovedSelected =
    approvedAds.length > 0 &&
    approvedAds.every((ad) => selectedAds.includes(ad.ad_id || ad.id));

  // 서버에서 이미 필터링된 데이터를 받으므로 정렬 제거
  const filteredAdData = adData;

  // API 연결 전 단계: 광고가 없으면 "등록된 광고가 없습니다" 메시지 표시
  if (!adData || adData.length === 0) {
    return (
      <div className="no-data-message">
        <p>등록된 광고가 없습니다</p>
      </div>
    );
  }

  // 쿠팡 방문 (missionTemplate: 13)인지 확인
  const isCoupangVisit = adData.some((ad) => ad.missionTemplate === 13);

  return (
    <div className="ad-table-container">
      <table className={`ad-table ${isCoupangVisit ? "coupang-visit" : ""}`}>
        <thead>
          <tr>
            <th style={{ width: "50px" }}>
              <input
                type="checkbox"
                checked={isAllApprovedSelected}
                onChange={(e) => handleSelectAll(approvedAds)(e)}
              />
            </th>
            <th>광고명</th>
            <th>메인키워드</th>
            <th>일일수량</th>
            <th>참여 현황</th>
            {/* {!isCoupangVisit && <th>시작순위</th>}
            {!isCoupangVisit && <th>현재순위</th>} */}
            <th>시작순위</th>
            <th>현재순위</th>
            <th>시작일</th>
            <th>종료일</th>
            <th>잔여기간</th>
            <th>진행상황</th>
            <th>상세보기</th>
          </tr>
        </thead>
        <tbody>
          {filteredAdData.map((ad) => (
            <tr key={ad.ad_id || ad.id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedAds.includes(ad.ad_id || ad.id)}
                  onChange={() => handleSelectAd(ad.ad_id || ad.id)}
                  disabled={ad.status !== "APPROVED"}
                />
              </td>
              <td className="ad-name-cell">
                <img
                  src={ad.imageUrl || "/logo192.png"}
                  alt={ad.missionName || "광고 이미지"}
                  className="ad-image"
                  onError={(e) => {
                    e.target.src = "/logo192.png";
                  }}
                />
                <div className="ad-name-content">
                  <span className="ad-description" title={ad.storeName || "-"}>
                    {ad.storeName || "-"}
                  </span>
                  <span
                    className="ad-name-link"
                    title={ad.missionName || "-"}
                    onClick={() => {
                      if (ad.productUrl) {
                        window.open(ad.productUrl, "_blank");
                      }
                    }}
                  >
                    {ad.missionName || "-"}
                  </span>
                </div>
              </td>
              <td>
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "block",
                  }}
                  title={(() => {
                    const keywords = keywordData[ad.ad_id] || [];
                    const mainKeyword = keywords.find((k) => k.type === "MAIN");
                    return mainKeyword?.name || ad.mainKeyword || "-";
                  })()}
                >
                  {(() => {
                    const keywords = keywordData[ad.ad_id] || [];
                    const mainKeyword = keywords.find((k) => k.type === "MAIN");
                    return mainKeyword?.name || ad.mainKeyword || "-";
                  })()}
                </span>
              </td>
              <td>{ad.dailyQuantity || "-"}</td>
              <td>{calculateParticipationStatus(ad)}</td>
                 
                <td>
                  {(() => {
                    const keywords = keywordData[ad.ad_id] || [];
                    const mainKeyword = keywords.find((k) => k.type === "MAIN");
                    const rank = mainKeyword?.initialRank || ad.initialRank;
                    return rank ? `${rank}위` : "-";
                  })()}
                </td>
              
                <td>
                  {(() => {
                    const keywords = keywordData[ad.ad_id] || [];
                    const mainKeyword = keywords.find((k) => k.type === "MAIN");
                    const rank = mainKeyword?.currentRank || ad.currentRank;
                    return (
                      <span
                        style={{
                          color: "#007bff",
                          fontWeight: "600",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        title="순위 체크 그래프 보기"
                        onClick={() => {
                          if (onOpenRankCheck) {
                            onOpenRankCheck(ad);
                          }
                        }}
                      >
                        {rank ? `${rank}위` : "-"}
                      </span>
                    );
                  })()}
                </td>
              
              {/* {!isCoupangVisit && (
                <td>
                  {(() => {
                    const keywords = keywordData[ad.ad_id] || [];
                    const mainKeyword = keywords.find((k) => k.type === "MAIN");
                    const rank = mainKeyword?.initialRank || ad.initialRank;
                    return rank ? `${rank}위` : "-";
                  })()}
                </td>
              )}
              {!isCoupangVisit && (
                <td>
                  {(() => {
                    const keywords = keywordData[ad.ad_id] || [];
                    const mainKeyword = keywords.find((k) => k.type === "MAIN");
                    const rank = mainKeyword?.currentRank || ad.currentRank;
                    return (
                      <span
                        style={{
                          color: "#007bff",
                          fontWeight: "600",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        title="순위 체크 그래프 보기"
                        onClick={() => {
                          if (onOpenRankCheck) {
                            onOpenRankCheck(ad);
                          }
                        }}
                      >
                        {rank ? `${rank}위` : "-"}
                      </span>
                    );
                  })()}
                </td>
              )} */}
              <td>
                {ad.startDate
                  ? ad.startDate.split("T")[0].replace(/-/g, ".")
                  : "-"}
              </td>
              <td>
                {ad.endDate ? ad.endDate.split("T")[0].replace(/-/g, ".") : "-"}
              </td>
              <td>
                <RemainingDaysBadge
                  startDate={ad.startDate}
                  endDate={ad.endDate}
                  status={ad.status}
                />
              </td>
              <td>
                <span className={`status-badge ${getStatusClass(ad.status)}`}>
                  {getStatusText(ad.status)}
                </span>
              </td>
              <td>
                <button
                  className="view-button"
                  onClick={() => {
                    // 원본 API 데이터와 키워드 데이터를 포함하여 전달
                    const enhancedAdData = {
                      ...ad,
                      mainKeywordName: (() => {
                        const keywords = keywordData[ad.ad_id] || [];
                        const mainKeyword = keywords.find(
                          (k) => k.type === "MAIN"
                        );
                        return mainKeyword?.name || "-";
                      })(),
                      subKeywordNames: (() => {
                        const keywords = keywordData[ad.ad_id] || [];
                        return keywords
                          .filter((k) => k.type === "SUB")
                          .map((k) => k.name);
                      })(),
                    };
                    onViewAd(enhancedAdData);
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#007bff",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                >
                  상세보기
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ShoppingAdTable;
